/**
 * withReadTimeout — o teto que NENHUM one-shot do app tinha (§BUG-179 adj. ⑤).
 *
 * `getDoc`/`getDocs` default esperam o SERVIDOR, e com o transporte morto
 * (suspensão de background — BUG-179) eles não assentam NUNCA: sem `.then`,
 * sem `.catch`, sem `.finally`, o `isLoading` do hook fica `true` para sempre
 * e a tela vira skeleton eterno. Medido em 29/08: ~10 buscas one-shot da Home,
 * do perfil público e dos contextos estavam assim.
 *
 * O teto converte "pendurado" em REJEIÇÃO — que cai no `catch` que cada hook
 * já tem (estado de erro ou vazio, os dois melhores que skeleton infinito).
 * 12s é folgado de propósito: rede lenta de celular não pode virar erro; o que
 * se quer pegar é o nunca.
 */
export const READ_TIMEOUT_MS = 12_000;

export async function withReadTimeout<T>(
  read: Promise<T>,
  timeoutMs: number = READ_TIMEOUT_MS,
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      read,
      new Promise<never>((_, reject) => {
        timer = setTimeout(
          () => reject(new Error("firestore read timeout")),
          timeoutMs,
        );
      }),
    ]);
  } finally {
    if (timer !== undefined) clearTimeout(timer);
  }
}
